import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';

import { clearStorage } from '../helpers/storage';

const instance = axios.create({
  baseURL: process.env.REACT_APP_MERCHANT_BANKING_API_BASE_URL,
});

const devInstance = axios.create({
  baseURL:
    process.env.REACT_APP_MERCHANT_BANKING_DEV_PLATFORM_TEST_API_BASE_URL,
});

const prodDevInstance = axios.create({
  baseURL:
    process.env.REACT_APP_MERCHANT_BANKING_DEV_PLATFORM_PROD_API_BASE_URL,
});

const retailInstance = axios.create({
  baseURL: process.env.REACT_APP_RETAIL_BANKING_API_BASE_URL,
});

const v2Instance = axios.create({
  baseURL: process.env.REACT_APP_MERCHANT_BANKING_API_BASE_URL_V2,
});

const api = (axios: AxiosInstance) => {
  return {
    get: <T>(url: string, config: AxiosRequestConfig = {}) =>
      axios.get<T>(url, config),

    post: <T>(url: string, body: unknown, config: AxiosRequestConfig = {}) =>
      axios.post<T>(url, body, config),

    put: <T>(url: string, body: unknown, config: AxiosRequestConfig = {}) =>
      axios.put<T>(url, body, config),

    patch: <T>(url: string, body: unknown, config: AxiosRequestConfig = {}) =>
      axios.patch<T>(url, body, config),

    delete: <T>(url: string, config: AxiosRequestConfig = {}) =>
      axios.delete<T>(url, config),
  };
};

const shouldExcludeFromInterceptor = (url: string) => {
  const excludedRoutes = [
    '/auth/login',
    '/auth/logout',
    '/auth/mfa/resend',
    '/register',
    '/auth/refreshToken',
    '/transfers',
    '/kyc/user',
  ];
  return excludedRoutes.some((route) => url.includes(route));
};

const handleUnauthorizedResponse = (error: unknown) => {
  const url =
    (error as { config?: { url?: string } })?.config?.url ?? '';

  if (
    !shouldExcludeFromInterceptor(url) &&
    (error as { response?: { status?: number } })?.response?.status === 401
  ) {
    clearStorage();
    globalThis.location.reload();
  }

  return Promise.reject(error);
};

instance.interceptors.response.use(
  (response) => response,
  handleUnauthorizedResponse,
);

v2Instance.interceptors.response.use(
  (response) => response,
  handleUnauthorizedResponse,
);

export const retailApi = api(retailInstance);

export const devApi = api(devInstance);

export const prodDevApi = api(prodDevInstance);

export const v2Api = api(v2Instance);

export default api(instance);
